export default (locationType: string | null) => {
  if (locationType === 'onsite') {
    return 'On Site';
  } else if (locationType === 'remote') {
    return 'To Work Remotely';
  } else {
    return null;
  }
};
